import styled from 'styled-components';
import { rem } from '../../utils';
export const StyledImageTemplateWrapper = styled.div `
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: ${({ theme }) => rem(theme.Border.Radius.Medium)};
`;
//# sourceMappingURL=SVGCard.style.js.map